export class JQueryHelper {
    private static isHiddenElement(index: number, e: HTMLElement) {
        const qElement = $(e);
        return qElement.css('display') === 'none' || qElement.css('visibility') === 'hidden';
    }

    public static visibilityText(elem: JQuery): string {
        const clone = elem.clone();
        clone.find('*').filter(JQueryHelper.isHiddenElement).remove();
        return clone.text();
    }
}
